import { render, staticRenderFns } from "./appointmentDetail.vue?vue&type=template&id=78b6e622&scoped=true&"
import script from "./appointmentDetail.vue?vue&type=script&lang=js&"
export * from "./appointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDetail.vue?vue&type=style&index=0&id=78b6e622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6e622",
  null
  
)

export default component.exports